document.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('a[href="#download-popup"]');
  const popup = document.getElementById('popup-download');
  const overlay = document.querySelector('.download-popup-overlay');
  const closeBtn = popup?.querySelector('.download__close-btn');
  const formBox = popup?.querySelector('.form-box');
  const successBox = popup?.querySelector('.success-download-box');
  const form = formBox?.querySelector('form');
  const errorMessage = document.getElementById('popup-download-error-message');

  // Open popup
  if (links.length && popup && overlay) {
    links.forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        popup.classList.remove('hidden');
        overlay.classList.remove('hidden');
        if (errorMessage) errorMessage.textContent = '';
      });
    });
  }

  function closePopup() {
    popup.classList.add('hidden');
    overlay.classList.add('hidden');
    formBox.classList.remove('hidden');
    successBox.classList.add('hidden');
    form.reset();
    if (errorMessage) errorMessage.textContent = '';
  }

  closeBtn?.addEventListener('click', closePopup);
  overlay?.addEventListener('click', closePopup);

  if (form) {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (errorMessage) errorMessage.textContent = '';

      const submitBtn = form.querySelector('button[type="submit"]');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Verwerken...';

      try {
        // Basis customer object
        const customerData = {
          tag: form.querySelector('[name="customer[tag]"]')?.value || 'E-book',
          firstname: form.querySelector('[name="customer[firstname]"]')?.value || '',
          lastname: form.querySelector('[name="customer[lastname]"]')?.value || '',
          email: form.querySelector('[name="customer[email]"]')?.value || ''
        };

        // Alleen toevoegen als phone ingevuld is
        const phoneInput = form.querySelector('[name="customer[phone]"]');
        if (phoneInput && phoneInput.value.trim() !== '') {
          customerData.phone = phoneInput.value;
        }

        // Alleen toevoegen als school input bestaat
        const schoolInput = form.querySelector('[name="customer[school]"]');
        if (schoolInput && schoolInput.value.trim() !== '') {
          customerData.school = schoolInput.value;
        }

        const payload = { customer: customerData };

        console.log('Verstuur JSON:', payload);

        const response = await fetch('https://wiseq.monkeydo.it/apps/customer', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        console.log('Response status:', response.status, response.statusText);

        let result;
        try {
          result = await response.json();
        } catch {
          result = await response.text();
        }

        if (!response.ok) {
          console.error('API error:', result);
          if (errorMessage) {
            errorMessage.textContent = result?.message || 'Er is iets misgegaan, probeer later opnieuw.';
          }
          return; // stop verdere verwerking
        }
        
        console.log('API response:', result);

        formBox.classList.add('hidden');
        successBox.classList.remove('hidden');

        // Meetpunt voor GTM (catalogus of e-book), zie snippets/wiseq-datalayer.liquid.
        try {
          document.dispatchEvent(new CustomEvent('wiseq:formulier-verzonden', {
            detail: { formulier: customerData.tag }
          }));
        } catch (e) {}
      } catch (err) {
        console.error('Fout bij verzenden:', err);
        alert('Er is iets misgegaan, bekijk de console voor details.');
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Download';
      }
    });
  }
});